<template>
  <v-container fluid grid-list-md>
    <h3>Timesheet Summary List</h3>
    <v-layout row wrap>
      <!-- Date pickers and button -->
      <v-flex xs12 sm6 md4 lg4>
        <v-date-picker
          v-model="fromDate"
        >
          <v-text-field
            box
            slot-scope='props'
            label="From"
            v-model='props.inputValue'
            append-icon="mdi-calendar-range"
            readonly
          >
          </v-text-field>
        </v-date-picker>
      </v-flex>
      <v-flex xs12 sm6 md4 lg4>
        <v-date-picker
          v-model="toDate"
        >
          <v-text-field
            slot-scope='props'
            label="To"
            v-model='props.inputValue'
            append-icon="mdi-calendar-range"
            readonly
            box
          >
          </v-text-field>
        </v-date-picker>
      </v-flex>
      <v-flex xs6 md4>
        <div class="text-xs-left">
          <v-btn 
            color="pipefishOrange"
            outline
            class="elevation-1"
            @click="getEntries"
          >
            Apply Dates
          </v-btn>
        </div>
      </v-flex>
      <!-- ====END=== -->
      <v-flex xs12 lg8 mb-3>
        <v-expansion-panel popout>
          <v-expansion-panel-content
            v-for="(userAccount,i) in users"
            :key="i"
          >
            <template v-slot:header>
              <div>
                <span class="subheading"> {{userAccount.name}}</span>
              </div>
            </template>
            <v-card>
              <v-card-text>
                <v-data-table
                  :headers="headers"
                  :items="userAccount.table"
                  class="elevation-1"
                  sort-icon="mdi-menu-down"
                  hide-actions
                >
                  <template v-slot:items="props">
                    <td> {{props.item.date}}</td>
                    <td> {{props.item.day}}</td>
                    <td> {{props.item.hours}}</td>
                    <td> {{props.item.leave}}</td>
                    <td :style="`backgroundColor: ${props.item.isLeave ? 'lightBlue' : ''} `"> {{props.item.activity}}</td>
                    <td> {{props.item.notes}} </td>
                    <td> {{ props.item.status }} </td>
                  </template>
                </v-data-table>

              </v-card-text>
              <v-card-actions>
                Total Hours: {{userAccount.totalHours}}
                <br>
                Total Days: {{userAccount.totalHours/8}}
              </v-card-actions>
              
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {
  mapState, mapMutations, mapActions
} from 'vuex'
import moment from 'moment'
var compare = function(a, b) {
  var nameA = a.name.toUpperCase()
  var nameB = b.name.toUpperCase()
  if(nameA < nameB) {
    return -1
  }
  if(nameA > nameB) {
    return 1
  }
  return 0
}

export default {
  props: ['selectedTo', 'selectedFrom'],
  // props: [to]
  data: () => ({
    fromDate: new Date(),
    toDate: new Date(),
    users: [],
    headers: [
      {text: 'Date', value: 'date'},
      {text: 'Day', value: 'day'},
      {text: 'Hours', value: 'hours'},
      {text: 'Leave', value: 'leave'},
      {text: 'Activity', value: 'activity'},
      {text: 'Notes', value: 'notes'},
      {text: 'Status', value: 'status'}
    ]
  }),
  created() {
    var self = this
    if(this.pipefishUsers.length == 0) {
      this.$timesheetApi.getAllUsers().then(users => {
        self.setSortedPipefishUsers(users)
      })
    }
    if(this.summary.length != 0) {
      this.toDate = this.selectedDates.to
      this.fromDate = this.selectedDates.from
      this.processEntries()
    }
  },
  computed: {
    ...mapState('admin', ['pipefishUsers', 'summary', 'selectedDates'])
  },
  methods: {
    ...mapMutations('admin', ['setSummary', 'setSelectedDates']),
    ...mapActions('admin', ['setSortedPipefishUsers']),
    /**
     * Get all the entries from the selected time frame
     */
    getEntries() {
      var self = this
      this.users = []
      var start = moment(this.fromDate).format("YYYY/MM/DD")
      var end = moment(this.toDate).format("YYYY/MM/DD")

      var selected = {
        to: this.toDate,
        from: this.fromDate
      }
      this.setSelectedDates(selected)

      this.$timesheetApi.getAllTimesheetEntries(start, end).then(entries => {
        self.setSummary(entries)
        self.processEntries()
      })
    },

    processEntries() {

      var allUsers = {}

      // Generate all the dates within the selected timeframe
      var start = moment(this.fromDate)
      var end = moment(this.toDate)
      
      var dates = {} // this can be a list instead of an object
      dates[start.startOf('day').format('DD-MM-YYYY')] = {
        actualDate: start,
      }
      var currDate = moment(start).startOf('day');
      var lastDate = moment(end).startOf('day');

      while(currDate.add(1, 'days').diff(lastDate) < 0) {
          dates[currDate.clone().format('DD-MM-YYYY')] = {
            actualDate: currDate.clone(),
          }
      }
      if(!start.isSame(end, 'day')) {
        dates[end.format('DD-MM-YYYY')] = {
          actualDate: end,
        }
      }
      // this.pipefishUsers.sort(compare)
      // Create a user object and each object should contain a list of dates
      this.pipefishUsers.forEach(user => {
        allUsers[user.id] = {
          name: `${user.GivenName} ${user.Surname}`,
          dates: {},
          id: user.id,
          email: user.EmailAddress,
          totalHours: 0
        }
        for(var date in dates) {
          allUsers[user.id].dates[date] = {
            entries: [],
            actualDate: dates[date].actualDate
          }
        }
      })

      // attach the entry to correct user under WorkedOn date
      this.summary.forEach(el => {
        var singleUser = allUsers[el.UserAccountId]
        var singleDate = singleUser.dates[moment(el.WorkedOn).format('DD-MM-YYYY')]
        singleDate.entries.push(el)
      })

      for(var personId in allUsers) {
        var person = allUsers[personId]
        var row = this.createTable(person)
        this.users.push(row)
      }
      this.users.sort(compare)
    },
    createTable(person) {
      person["table"] = []
      for(var date in person.dates) {
        var rowDate = person.dates[date]
        var tableRow = {}
        if(rowDate.entries.length == 0) {
          tableRow = {
            date: rowDate.actualDate.format('DD/MM/YYYY'),
            day: rowDate.actualDate.format('dddd'),
            hours: '-',
            leave: '-'
          }
          person["table"].push(tableRow)
        } else {
          rowDate.entries.forEach(entry => {
            tableRow = {
              date: rowDate.actualDate.format('DD/MM/YYYY'),
              day: rowDate.actualDate.format('dddd'),
              hours: entry.activity.IsLeave ? '-' : entry.HoursWorked,
              leave: entry.activity.IsLeave ? entry.HoursWorked: '-',
              isLeave: entry.activity.IsLeave,
              activity: entry.activity.Name,
              notes: entry.Notes,
              status: entry.approval ? entry.approval.Status : 'Not Approved'
            }
            person["table"].push(tableRow)
          })
        }
        person.totalHours += rowDate.entries.filter(entry => !entry.activity.IsLeave).map(entry => entry.HoursWorked).reduce(function(a, b) { return a + b; }, 0)
        // activitiesLength.reduce(function(a, b) { return a + b; }, 0);
      }
      return person
    }
  }

}
</script>

<style>

</style>
